module.exports = __webpack_public_path__ + "769de2248efca00d00b96fb3337507bd.png";